import { render } from "./Security.vue?vue&type=template&id=635b86a5&scoped=true"
import script from "./Security.vue?vue&type=script&lang=js"
export * from "./Security.vue?vue&type=script&lang=js"

import "./Security.vue?vue&type=style&index=0&id=635b86a5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-635b86a5"],['__file',"src/pages/ddv-home/Security.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "635b86a5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('635b86a5', __exports__)) {
    api.reload('635b86a5', __exports__)
  }
  
  module.hot.accept("./Security.vue?vue&type=template&id=635b86a5&scoped=true", () => {
    api.rerender('635b86a5', render)
  })

}


export default __exports__